export default "__VITE_ASSET__C$JSF0FF__"